<template>
  <!-- -->
  <yq-table :data="data" height="100%" stripe border >
    <yq-table-column  label="班组名称" prop="classmateName" min-width="180rem"/>
    <yq-table-column label="负责人" prop="leaderName"/>
    <yq-table-column label="标段" prop="lotName"/>
    <yq-table-column label="施工工地" prop="siteName"/>
    <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
      <template v-slot="{row, $index}">
        <table-button-group label="更多操作">
          <table-button type="write" @click="$router.push(`/project/classmate/detail?id=${row.id}`)">编辑</table-button>
          <table-button type="delete" el-type="danger" message="移除施工班组并不会真的删除数据，只会将施工班组从工地中移除，如果要删除数据请在施工班组功能中进行操作" @click="deleteRow(row.id, $index)">移除</table-button>
        </table-button-group>
      </template>
    </yq-table-column>
  </yq-table>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import classmateApi from "@/api/dz-luqiao/luqiaoClassmateApi";

export default {
  props: {
    data: {default: () => []},
  },
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "",
  components: {
    YqTableColumn, TableButton, TableButtonGroup
  },
  data() {
    return {

    };
  },
  created() {
  },
  methods: {
    async deleteRow(id, idx){
      await classmateApi.deleteClassmateFromSite(id);
      // eslint-disable-next-line vue/no-mutating-props
      this.data.splice(idx, 1);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>